import React from 'react';
import FadeIn from '../ui/FadeIn';
import Button from '../ui/Button';

const Editorial = () => {
  const scrollToForm = () => {
    document.getElementById('inquire').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-32 px-6 overflow-hidden flex items-center justify-center min-h-[70vh]">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://ik.imagekit.io/aeu02xvjgn/Oct17.jpg" 
          alt="Cinematic background" 
          className="w-full h-full object-cover object-center scale-110 blur-[2px] opacity-40"
        />
        <div className="absolute inset-0 bg-charcoal/90"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <FadeIn>
          <div className="flex items-center justify-center gap-6 mb-10">
            <div className="w-16 h-px bg-gold/40"></div>
            <span className="font-script text-gold text-3xl">October 17</span>
            <div className="w-16 h-px bg-gold/40"></div>
          </div>
          
          <h2 className="font-serif text-4xl md:text-6xl text-ivory mb-8 leading-[1.2]">
            The Date Is Open. <br/>
            <span className="italic text-stone/80 font-light">The Story Is Yours.</span>
          </h2>
          
          <p className="text-stone font-light text-lg md:text-xl leading-relaxed mb-12 italic font-serif">
            "Some wedding dates are planned years ahead. Others arrive at just the right time. October 17 is for the couple ready to begin their next chapter in a setting that already feels timeless."
          </p>
          
          <Button variant="primary" onClick={scrollToForm} className="px-12">
            Request Availability
          </Button>
        </FadeIn>
      </div>
    </section>
  );
};

export default Editorial;